<template>
  <div class="pa-1">
    <v-card v-if="isRegistered">
      <v-card-title>
        <h2>مرحبا!</h2>
      </v-card-title>
      <v-card-text>
        <div>{{ customerInfo.fullName }}</div>
      </v-card-text>
    </v-card>
    <v-card v-else max-width="620px" class="mx-auto">
      <v-img max-height="125" contain src="@/assets/logo.jpg"></v-img>
      <v-card-title>
        <h2>إنشاء حساب</h2>
      </v-card-title>
      <v-card-text>
        <v-form>
           <v-text-field
            v-model="email"
            prepend-icon="mdi-email"
            label="الايميل"
          />
          <div dir="ltr">
            <VuePhoneNumberInput
              :only-countries="countriesList"
              v-model="phone"
              default-country-code="KW"
              :translations="translations"
              @update="onUpdate"
            />
          </div>

          <v-text-field
            v-model="password"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            label="كلمة السر"
          />
          <v-text-field
            v-model="confirmPassword"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            label="تأكيد كلمة السر"
          />
        </v-form>
        <v-alert v-if="showError" type="error"> خطأ </v-alert>
      </v-card-text>
      <v-card-actions justify-center>
        <v-btn @click="signUp" :loading="isSigningUp" color="success" block
          >إنشاء الحساب</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  name: "SignUpComponent",

  //********************** */
  props: {},

  //********************** */
  components: {
    VuePhoneNumberInput,
  },

  //********************** */
  data: () => ({
    showPassword: false,
    showError: false,
    password: "",
    confirmPassword: "",
    phone: "",
    email: "",
    countryCode: "",
    isSigningUp: false,
    translations: {
      countrySelectorLabel: "الدولة",
      countrySelectorError: "يرجى اختيار الدولة",
      phoneNumberLabel: "رقم الهاتف",
      example: "50399591",
    },
    countriesList: ["KW", "SA", "BH", "OM", "QA", "AE"],
  }),

  //********************** */
  computed: {
    ...mapGetters("Account", {
      isLoggedIn: "isLoggedIn",
      isRegistered: "isRegistered",
      customerInfo: "customerInfo",
    }),
    isLogInInfoValid: function () {
      return this.email !== "" && this.password !== "";
    },
  },

  //********************** */
  methods: {
    signUp: async function (){
      this.isSigningUp = true;
      try {
        await this.$store.dispatch("Account/signUp", {
          name: this.name,
          email: this.email,
          phone: this.phone,
          password: this.password,
        });
        this.$store.dispatch("loadToken");
        await this.$store.dispatch("Cart/loadCart");
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        alert(error);
      }
      this.isSigningUp = false;
    },

    onUpdate: function (payload) {
      this.countryCode = payload.countryCode;
    },
  },

  //*********************** */
  async mounted() {},
};
</script>

<style>
</style>